/**
 * Dependencies.
 */
import { UserModel } from '@/api/service-point/user/user.model';
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

/**
 * Service.
 */
class UsersService extends BaseService<UserModel> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      UserModel,
      UserModel.name,
      applicationConstant.apiServicePointPrivateUrl
    );
  }

  /**
   * Method `validateUserEmail`.
   */
  validateUserEmail({ email }: { email?: string }) {
    const endpoint = `${this.getModelEndpoint}/${email}/validate`;

    return this.GET(endpoint, {});
  }

  /**
   * Method `getUserProzisPoints`.
   */
  getUserProzisPoints() {
    const endpoint = `${this.getModelEndpoint}/prozisPoints`;

    return this.GET(endpoint, {});
  }
}

/**
 * Export `usersService`.
 */
export const usersService = new UsersService();
